// extracted by mini-css-extract-plugin
export default {"round":"PairTask_round__quers","round_number":"PairTask_round_number__ThLvj","round_word":"PairTask_round_word__8jbRo","team":"PairTask_team__Vqsma"};